/**
 * The desktop page grid, in the two facts both columns have to agree on.
 *
 * The left column is the shell's (logo, then nav); the right column is the
 * screen's (greeting, then the habit chart). Give both a first child of
 * `TOP_BAND` height and the same `BAND_GAP`, and their second children start
 * on the same line — the nav's top meets the chart's top with nothing
 * measuring anything.
 */
export const TOP_BAND = 'h-12';

/** Passed as `gap` to the VStack of both columns. */
export const BAND_GAP = 6;

/**
 * Trailing space inside every scrolling screen, so the last row clears the
 * floating tab bar.
 *
 * It belongs to the SCROLLER, not to the shell. The shell used to reserve
 * the band with `pb-20` on the phone container, which stopped the scroll
 * area 80px above the bottom and left a strip of dead page behind the bar —
 * visible the moment the bar slid away, and unreachable by content the whole
 * time. Padding inside the scroller lets the list run to the bottom edge and
 * pass under the bar, which is why the bar is translucent.
 *
 * Harmless on desktop, where the nav is a left rail: it reads as a little
 * slack at the end of a long page.
 */
export const BOTTOM_CLEARANCE = 'pb-28';
